import axios from "axios";


export const findAuthorities = (headers) => {
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/authorities`, {
        headers
    })
}
